const FAVICON_SIZE = 32;

/**
 * Converts an SVG data URL to a PNG data URL for use as a favicon.
 * Many browsers do not support SVG favicons; PNG has broad support.
 * @param {string} svgDataUrl - Data URL of the form data:image/svg+xml,...
 * @param {number} [size=32] - Output width and height in pixels
 * @returns {Promise<string>} Promise that resolves to a PNG data URL
 */
export function svgDataUrlToPngDataUrl(svgDataUrl, size = FAVICON_SIZE) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas 2d context not available'));
        return;
      }
      ctx.drawImage(img, 0, 0, size, size);
      try {
        resolve(canvas.toDataURL('image/png'));
      } catch (e) {
        reject(e);
      }
    };
    img.onerror = () => reject(new Error('Failed to load SVG image'));
    img.src = svgDataUrl;
  });
}
